import { DiwaAPI } from './client'

/** Mirrors POST /people/{id}/enrich (202) in products/diwa/src/diwa/enrichment/router.py */
export interface EnrichResponse {
  status: 'queued' | 'already_pending'
  job_id?: string
  person_id: string
}

export class EnrichmentAPI {
  private api: DiwaAPI

  constructor(baseUrl: string) {
    this.api = new DiwaAPI(baseUrl)
  }

  /** Enqueue enrichment. Resolves on 202; rejects on 404 / 503 (queue unavailable). */
  enrich(personId: string): Promise<EnrichResponse> {
    return this.api.post<EnrichResponse>(`/people/${personId}/enrich`, {})
  }
}

/** Statuses at which polling should stop. */
export const TERMINAL_STATUSES = new Set(['done', 'manual', 'not_found', 'failed'])
